function createShareButtons (pageUrl) {
  document.querySelector('.share_button_facebook').addEventListener('click', () => {
    const url = 'https://www.facebook.com/sharer.php?u=' + pageUrl
    socialWindow(url)
  })

  document.querySelector('.share_button_twitter').addEventListener('click', () => {
    const url = 'https://twitter.com/intent/tweet?url=' + pageUrl
    socialWindow(url)
  })

  document.querySelector('.share_button_linkedin').addEventListener('click', () => {
    const url = 'https://www.linkedin.com/sharing/share-offsite/?url=' + pageUrl
    socialWindow(url)
  })
}

function setupTwitterLikes () {
  document.querySelector('.icon__twitter-like').addEventListener('click', (e) => {
    e.preventDefault()
    const url = e.target.closest('a').getAttribute('href')
    socialWindow(url)
  })
}

function setupTwitterComments () {
  document.querySelector('.icon__twitter-comment').addEventListener('click', (e) => {
    e.preventDefault()
    const url = e.target.closest('a').getAttribute('href')
    socialWindow(url)
  })
}

function setupTwitterRetweets () {
  document.querySelector('.icon__twitter-retweet').addEventListener('click', (e) => {
    e.preventDefault()
    const url = e.target.closest('a').getAttribute('href')
    socialWindow(url)
  })
}

function socialWindow (url) {
  var left = (window.innerWidth - 570) / 2
  var top = (window.innerHeight - 570) / 2
  var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left
  window.open(url, 'NewWindow', params)
}

if (document.querySelector('[class^=share_button]') !== null) {
  createShareButtons(encodeURIComponent(window.location.href))
}

if (document.querySelector('[class^=icon__twitter-]') !== null) {
  setupTwitterComments()
  setupTwitterRetweets()
  setupTwitterLikes()
}
